import EficienciaAgenciaPage from "./EficienciaAgenciaPage";

export {EficienciaAgenciaPage}
export default EficienciaAgenciaPage
